function view (path) {
  return () => import(/* webpackChunkName: '' */ '@/views/cco/' + path).then(m => m.default || m) // eslint-disable-line prefer-template
}

const ccoRoutes = [
  {
    path: '/cco/dashboard',
    component: view('Dashboard'),
    name: 'cco.dashboard',
    meta: {
      breadcrumb: [
        {
          text: 'Home'
        },
        {
          text: 'Dashboard',
          active: true
        }
      ]
    }
  },
  {
    path: '/cco/sales-order',
    component: view('SalesOrder'),
    name: 'cco.sales-order',
    meta: {
      breadcrumb: [
        {
          text: 'Home'
        },
        {
          text: 'Sales Order',
          active: true
        }
      ]
    }
  },
  {
    path: '/cco/sales-order-tracker/:status?',
    component: view('SalesOrderTracker'),
    name: 'cco.sales-order-tracker',
    meta: {
      breadcrumb: [
        {
          text: 'Home'
        },
        {
          text: 'Sales Order Tracker',
          active: true
        }
      ]
    }
  }
]

export default ccoRoutes
